import React from 'react';

const BankTransferContact = () => {
  return (
    <div className='mt-8 text-center'>
      <h4 className='text-sm font-medium text-slate-700 mb-2'>Contacto por dudas o confirmación de pago</h4>
      <div className='flex flex-col sm:flex-row items-center justify-center gap-3 text-slate-700'>
        <a href='mailto:legal@claimup.io' className='underline hover:text-slate-900'>
          legal@claimup.io
        </a>
        <span className='hidden sm:inline text-slate-300'>·</span>
        <a href='tel:+34604160995' className='underline hover:text-slate-900'>
          +34 604 160 995
        </a>
      </div>
    </div>
  );
};

export default BankTransferContact;
